export interface Notification {
  _id?: string
  id?: string
  title: string
  walletAddress: string
  message: string
  type?: 'messages' | 'war' | 'alliance' | 'system' | 'reports' | 'diplomacy'
  timestamp?: number
  createdAt?: string
  read?: boolean
  isRead?: boolean
  /** Client-localization hint: render from `notifications.content.<i18nKey>` with
   *  `i18nParams` interpolated; the stored title/message are the English fallback. */
  i18nKey?: string | null
  i18nParams?: Record<string, unknown> | null
  /** Structured payload for actionable notifications, e.g. an MvM reinforcement
   *  `{ kind: 'mvm-reinforce', attackId, defenderWallet, worldId, ... }` that drives a
   *  "Help defend" button. Passed straight through by the reducers. */
  metadata?: Record<string, unknown> | null
}

export interface NotificationState {
  notifications: Notification[]
  unreadCount: number
  /** Alliance manage live chat: new messages while user is not on the Messages tab (sidebar red dot). */
  allianceManageChatUnread?: number
  unreadCounts?: {
    messages: number
    war: number
    alliance: number
    system: number
    reports: number
    diplomacy: number
  }
}

export const initialNotificationState: NotificationState = {
  notifications: [],
  unreadCount: 0,
  allianceManageChatUnread: 0,
  unreadCounts: {
    messages: 0,
    war: 0,
    alliance: 0,
    system: 0,
    reports: 0,
    diplomacy: 0,
  },
}

